<div class="avatar layout-column layout-align-center-center"
     [ngClass]="{small: !!isSmall}"
     [ngStyle]="{ 'background-color': color }">
  <span *ngIf="!url && !!name" class="br-head-3">{{name[0]}}</span>
  <img *ngIf="!!url"
       alt="Avatar"
       class="avatar"
       [ngClass]="{small: !!isSmall}"
       src="{{url}}">
  <div class="online"></div>
  <div *ngIf="count" class="count badge bg-secondary rounded-pill">{{count}}</div>
</div>
